import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
    EmployeeApplicationConfig, EmployeeApplicationConfigSaveModel,
    IEmployeeApplicationConfigListItem
} from '../models/EmployeeApplicationConfig';

import { environment as ENV } from '../../environments/environment';

/**
 * Employee application configuration service
 */
@Injectable({ providedIn: "root" })
export class EmployeeApplicationConfigService {
    constructor(public http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/employeeApplicationConfig` }

    get(): Observable<IEmployeeApplicationConfigListItem[]> {
        return this.http.get<IEmployeeApplicationConfigListItem[]>(this.apiUrl);
    }

    getById(id: number): Observable<EmployeeApplicationConfig> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<EmployeeApplicationConfig>(url);
    }

    save(item: EmployeeApplicationConfigSaveModel): Observable<number> {
        return this.http.put<number>(this.apiUrl, item)
    }

    publish(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/publish`;
        return this.http.post(url, null);
    }

    unpublish(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/unpublish`;
        return this.http.post(url, null);
    }

    activate(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/activate`;
        return this.http.post(url, null);
    }

    deactivate(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/deactivate`;
        return this.http.post(url, null);
    }

    delete(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.delete(url);
    }

    testDataSource(database: string, procedure: string): Observable<any[]> {
        const url = `${this.apiUrl}/testDataSource`;
        return this.http.get<any[]>(url, {
            params: {
                database,
                procedure
            }});
    }

    /**
     * Get available base template tags.
     */
    getBaseTemplateTags(): Observable<string[]> {
        const url = `${this.apiUrl}/baseTemplateTags`;
        return this.http.get<string[]>(url);
    }

    getDatabases(): Observable<string[]> {
        const url = `${this.apiUrl}/databases`;
        return this.http.get<string[]>(url);
    }
}
